import SelectDataExchange from './SelectDataExchange'

export default class AttractionsWFFMDataExchange extends SelectDataExchange {
  /**
   * @param {HTMLFormElement} form
   */
  constructor (form) {
    super(form, form.querySelector('.custom-select-attractions select'), 'Attractions')
  }
}



// WEBPACK FOOTER //
// ./src/services/AttractionsWFFMDataExchange.js